export default __webpack_public_path__ + "static/media/full1.678a740d.jpg";